import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAuth0 } from '@auth0/auth0-angular';
import { AUTH0_WRAPPER_CONFIG, authInterceptor, getCookie } from '@auth/bp-pf-auth';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { auth0WrapperConfig, authConfig } from './modules/auth/auth0-config/auth0-config';
import { supportLibConfig } from './modules/auth/auth0-config/support-config';
import { SUPPORT_LIB_CONFIG } from '@support/bp-pf-support';
import { provideBpTheme } from '@support/bp-pf-theme';
import { environment } from '../environments/environment';
import { provideBpPfChatbot } from '@chat/bp-pf-chatbot';
import { PermissionService } from './modules/auth/services/permission.service';
import { provideDashboard } from '@dashboard/bp-pf-dashboard';


const tenantId = getCookie(`${environment.app_id}_tenant_code`);

const emailId = getCookie(
  `${tenantId}_${environment.app_id}_email`
);

export function initializePermissions(permissionService: PermissionService) {
  return () => permissionService.loadPermissions();
}

export const appConfig: ApplicationConfig = {
  providers: [provideAnimations(),

  provideRouter(routes),
  provideBpTheme('sense'),
  // provideClientHydration(),
  provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
  provideAuth0(authConfig.Auth0Data),
  { provide: AUTH0_WRAPPER_CONFIG, useValue: auth0WrapperConfig },
  { provide: SUPPORT_LIB_CONFIG, useValue: supportLibConfig },
  provideToastr(),

  provideBpPfChatbot({
    appId: environment.app_id,
    // tenantId: tenantId,
    // appId: 'rac-dev',
    tenantId: '3f49c8a9-79d4-4d51-9e72-88f7f654c3a6',
    connectionType: 'azure-pubsub',
    // socketBaseUrl: 'https://pf-bp-dev-chat-engine-as.azurewebsites.net',
    socketBaseUrl: environment.socketBaseUrl,

    // connectionType: 'wss',
    // socketBaseUrl: 'wss://pf-bp-dev-chatengine-as.azurewebsites.net/chat-engine-ws',

    chatApiBaseUrl: environment.chatApiBaseUrl,
    // chatApiBaseUrl: 'https://sense-dev-core-backend-service-as.azurewebsites.net'
    responseCancelTimeoutMilliseconds: 120000 // wait for 30 seconds before cancelling the streaming
  }),
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: initializePermissions,
    deps: [PermissionService]
  },
  provideDashboard({
    dashboardUrl: environment.dashboardUrl,
  
  })
  ]
};


